import wx from 'weixin-js-sdk'
//import {wechatShare} from "@/unit/global";
const jsApiList = ['updateAppMessageShareData', 'updateTimelineShareData']
function weixinShare(url, dataForWeixin,obj) {
    // wechatShare获取后台返回的签名等中重要参数信息，这里后台代码就不贴出来了
    //wechatShare(url).then(res => {
        wx.config({
            debug: false,
            appId: obj.appId,
            timestamp: obj.timestamp,
            nonceStr: obj.nonceStr,
            signature: obj.signature,
            jsApiList: jsApiList
        })
        wx.ready(function () {
            wx.updateAppMessageShareData({
                title: dataForWeixin.title,
                desc: dataForWeixin.desc,
                // link: dataForWeixin.link,
                // imgUrl: dataForWeixin.imgUrl,
                success: function success(res) {

                },
            });

            wx.updateTimelineShareData({
                title: dataForWeixin.title,
                // link: dataForWeixin.link,
                // imgUrl: dataForWeixin.imgUrl,
                success: function success(res) {
                },
            });
        })
   //})
}
export default {
    weixinShare: weixinShare
}